<template>
  <kst-print class="kst-stockreduction-printdetails" :error="error" :loading="isLoading">
    <template #header>
      <div class="columns is-mobile">
        <div class="column is-half">
          <Company :data="companyData"/>
        </div>
        <div class="column is-half">
          <div class="is-size-3">{{ title }}</div>
        </div>
      </div>

      <div class="columns is-mobile">
        <div class="column">
          <Details :data="data"/>
        </div>
      </div>
    </template>

    <Items class="mt-4" :data="data" :items="data.Items"/>
    <Total class="mt-4" :data="data" :items="data.Items" />
  </kst-print>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../StockReductionInfo.js";
import Model from "../StockReductionModel.js";
import Services from "../StockReductionServices.js";

import Company from "@/components/Settings/Company/PrintDetails/CompanyPrintDetails";
import Details from "./StockReductionPrintDetails_Details";
import Items from "./StockReductionPrintDetails_Items";
import Total from "./StockReductionPrintDetails_Total";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Company,
    Details,
    Items,
    Total
  },
  data: () => ({
    data: {},
    companyData: {},
    isLoading: true,
    // error
    error: null
  }),
  computed: {
    title() {
      return Model.Module.FullName;
    }
  },
  created(){
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.error = null;

      if (!id) {
        this.error = Info.Message.PrintDetails_ParamIncomplete;
        return;
      }

      this.data = {};
      this.companyData = {};

      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.error = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetails(id) {
      const config = Services.getStockReductionDetailsData(id, { withcompany: 1 });
      this.runAxios(config, null,
        this.loadDetails_Success,
        this.loadDetails_Error,
        this.loadDetails_Invalid
      );
    },
    loadDetails_Success(data) {
      this.data = data.Details;
      for (const item of this.data.Items) {
        Model.updateItemByPackaging(item);
      }
      Model.updateDetailsByDetailsData(this.data, data);

      this.companyData = data.CompanyDetails;
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.error = message;
      this.initLoad_End();
    },
    loadDetails_Invalid(message) {
      this.error = message;
      this.initLoad_End();
    }
  }
}
</script>